module.exports = __webpack_public_path__ + "static/media/message-icon.0c8dac80.png";